import axios from 'axios';
import { config } from '../config';

export async function getFeatureFlagsWithoutToken() {
  const result = await axios({
    method: 'GET',
    url: `${config.core.featureFlagsServiceUrl}/v1.0/feature-flags`,
  });
  return result.data;
}

export function getAllFeatureFlags() {
  return {
    method: 'GET',
    url: `${config.core.featureFlagsServiceUrl}/v1.0/feature-flags`,
  };
}

export function updateFeatureFlag(data) {
  return {
    method: 'PUT',
    url: `${config.core.featureFlagsServiceUrl}/v1.0/feature-flags/toggle`,
    data,
  };
}
